import { dollarsToCents, LedgerExpenseRow, LedgerPeriod, LedgerSaleRow, YearSummary, } from "../models/DealerLedger.js";
import { ViewModel } from "../mvvm/ViewModel.js";
const today = () => new Date().toISOString().slice(0, 10);
/** Dealer ledger and year summary, in dollars. */
export class DealerLedgerViewModel extends ViewModel {
    client;
    constructor(client) {
        super({ sales: [], expenses: [], summary: null, loading: false, error: null });
        this.client = client;
    }
    async loadLedger(period = LedgerPeriod.all()) {
        const ok = await this.run(async () => {
            const ledger = await this.client.businessLedger();
            this.setState({
                sales: ledger.sales
                    .filter((s) => period.matches(s.soldDate))
                    .map(LedgerSaleRow.fromBridge),
                expenses: ledger.expenses
                    .filter((e) => period.matches(e.date))
                    .map(LedgerExpenseRow.fromBridge),
            });
            return true;
        }, "Failed to fetch ledger.");
        return ok === true;
    }
    async loadSummary() {
        const ok = await this.run(async () => {
            this.setState({ summary: YearSummary.fromBridge(await this.client.businessSummary()) });
            return true;
        }, "Failed to load business summary.");
        return ok === true;
    }
    /** Payroll rows for the team page. */
    payrollExpenses() {
        return this.state.expenses.filter((e) => e.category === "Payroll");
    }
    async recordExpense(entry) {
        const ok = await this.run(async () => {
            const date = entry.date || today();
            await this.client.recordExpense({
                amountCents: dollarsToCents(entry.amount),
                category: entry.category || "General",
                note: entry.description,
                date,
            });
            if (entry.internalRepair && entry.listingId) {
                await this.client.recordExpense({
                    amountCents: dollarsToCents(-Math.abs(entry.amount)),
                    category: "Internal Revenue",
                    note: `Internal Service Margin for: ${entry.description}`,
                    date,
                });
            }
            return true;
        }, "Failed to record expense.");
        return ok === true;
    }
}
//# sourceMappingURL=DealerLedgerViewModel.js.map